import React, { FC } from 'react';
import { useMCC } from '~/hooks';
import { Select } from 'antd';

const MCCInput: FC<any> = (props) => {
  const { codes } = useMCC();
  const options: MCCOption[] | undefined = codes?.map((item) => ({
    value: item.id || '',
    label: item.name,
  }));
  return (
    <Select
      options={options}
      showSearch
      optionFilterProp="children"
      filterOption={(input: string, option: MCCOption) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      {...props}
    />
  );
};

type MCCOption = { label?: string; value: string };

export default MCCInput;
